function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 34 34",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M29.83 24.58c.11.16.17.31.17.45 0 .13-.06.28-.17.44l-4.36 4.36a.78.78 0 01-.44.17.78.78 0 01-.45-.17L17 22.25l-7.58 7.58a.78.78 0 01-.45.17.78.78 0 01-.44-.17l-4.36-4.36a.78.78 0 01-.17-.44c0-.14.06-.29.17-.45L11.75 17 4.17 9.42A.78.78 0 014 8.97c0-.13.06-.28.17-.44l4.36-4.36c.16-.11.3-.17.44-.17s.29.06.45.17L17 11.75l7.58-7.58a.78.78 0 01.45-.17c.13 0 .28.06.44.17l4.36 4.36c.11.16.17.3.17.44s-.06.29-.17.45L22.25 17z"
})));